import React from "react";
import { Footer } from "../../components/Footer";
import { Nav } from "../../components/Nav";
import symetriaLogo from "../../../static/img/testimonials/symetriaLogo.png";
import sassettiLogo from "../../../static/img/testimonials/sassetti.png";
import tdpLogo from "../../../static/img/testimonials/tdp.png";
import "./style.css";

export const TestimonialsPage = () => {
    return (
        <div className="main testimonial" id="testimonials">
            <div className="overlap">
            <div className="content">
                <div className="element hero bg-white">
                    <div className="frame">
                        <p className="heading color-black">
                        Real experiences from top talent and leading companies—see how we connect the right people with the right opportunities.
                        </p>
                    </div>
                    <div className="image">
                        <div className="group">
                            <div className="rectangle" />
                        </div>
                    </div>
                </div>
                <div className="element bg-white">
                    <div className="frame">
                        <div className="testimonial-segment">

                            <div className="testimonial-block">
                                <div className="testimonial-title">
                                    <div className="block-title color-black">
                                    Symetria Recovery
                                    </div>
                                    <div className="companyLogo">
                                        <img src={symetriaLogo} 
                                        className="companyLogo-img"
                                        />
                                    </div>
                                </div>
                                <div className="testimonial-text">
                                    <div className="block-text color-black">
                                        <p>
                                        “It was our first opportunity to work with recruit22, and we couldn’t have been more pleased and satisfied with the business partnership.  
                                        They jumped into action very quickly, providing us with qualified candidates that met the specifics we were looking for in an executive position.   
                                        Their communication was exceptional, resourceful and made sure our needs were met.  
                                         We hired our executive from the candidates they presented to us and it is a perfect fit. I would use them again, and highly recommend their services.”
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="testimonial-block">
                                <div className="testimonial-title">
                                    <div className="block-title color-black">
                                    Sassetti CPAs
                                    </div>
                                    <div className="companyLogo">
                                        <img src={sassettiLogo} 
                                        className="companyLogo-img"
                                        />
                                    </div>
                                </div>
                                <div className="testimonial-text">
                                    <div className="block-text color-black">
                                        <p>
                                        "Working with recruit22 has been a game-changer for our firm. They truly go above and beyond to meet our recruiting needs, consistently delivering exceptional 
                                        service and results. The team is resourceful and always thinks outside the box, ensuring we find the right candidates for every position. Their regular check-ins 
                                        show a deep commitment to client service, which is something I haven’t experienced with other recruiters. They have set the bar high,
                                         and I can confidently say that our experience with recruit22 has been far superior to any other recruiting agency we've partnered with in the past."
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="testimonial-block">
                                <div className="testimonial-title">
                                    <div className="block-title color-black">
                                    The Dandelion Philosophy
                                    </div>
                                    <div className="companyLogo">
                                        <img src={tdpLogo} 
                                        className="companyLogo-img"
                                        />
                                    </div>
                                </div>
                                <div className="testimonial-text">
                                    <div className="block-text color-black">
                                        <p>
                                        “We are thrilled to have partnered with recruit22. Their recruitment expertise and standards have been invaluable to The Dandelion Philosophy. 
                                        The team’s commitment to understanding our unique mission and values has consistently led to exceptional, high quality candidate matches that 
                                        align with our organisational goals. From start to finish, recruit22 ensures a seamless process, providing professional, responsive, and personalised service.
                                         We highly recommend recruit22 for any organisation seeking dedicated recruitment support.” 
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <Footer
                    footer="default"
                />
            </div>
            <Nav className="nav-instance" nav="default" />
            </div>
        </div>
    );
};
